module.exports = __webpack_public_path__ + "static/results-tear-troughs-before-57ddc59454c79f03bb572624ad2a20c7.jpg";